import createErrors from '../createErrors';
import { type Page } from './constants';

export type Component = 'ResetPassword';

/**
 * Errors related to the Reset Password page
 */
export const Errors = createErrors<Page, Component>('ResetPassword')({
    ResetPassword: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to reset password',
        },
        Auth0EmailFailed: {
            severity: 'HIGH',
            message: 'Auth0 password reset email request failed',
        },
    },
    ChangePassword: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to change password',
        },
    },
});
